import { DEVICE_ACTION_TYPE, DeviceActions } from './device-type';
import { RootState } from '../../../../redux/root-reducer';

export enum DEVICE_STATE_KEY {
  DEVICE_LIST = 'list',
  ALERT_SUCCESS = 'alert_success',
  ALERT_FAILURE = 'alert_failure',
  MAX_DEVICE_LOGIN = 'max_device_login',
}

export type AlertData = {
  isVisible: boolean,
  translationValues?: {
    deviceDisplay: string,
  },
};

export type DeviceState = {
  [DEVICE_STATE_KEY.DEVICE_LIST]?: object,
  [DEVICE_STATE_KEY.MAX_DEVICE_LOGIN]?: string,
  [DEVICE_STATE_KEY.ALERT_SUCCESS]?: AlertData,
  [DEVICE_STATE_KEY.ALERT_FAILURE]?: AlertData,
};

const initialState: DeviceState = {
  [DEVICE_STATE_KEY.DEVICE_LIST]: [],
  [DEVICE_STATE_KEY.ALERT_SUCCESS]: {
    isVisible: false,
    translationValues: {
      deviceDisplay: '???',
    },
  },
  [DEVICE_STATE_KEY.ALERT_FAILURE]: {
    isVisible: false,
    translationValues: {
      deviceDisplay: '???',
    },
  },
};

export const deviceReducers = (state = initialState, action: DeviceActions) => {
  switch (action.type) { // NOSONAR [typescript:S1301] followed usage pattern of reducer
    case DEVICE_ACTION_TYPE.SET_DEVICE_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
};

export const deviceStateSelector = (key: DEVICE_STATE_KEY) => (state: RootState) => state.device[key];
